import styled from 'styled-components';
import { Button } from '../../components/utils/Button/Button';
import { Text16Bold } from '../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2.4rem;
  flex-grow: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const NoteText = styled(Text16Bold)`
  color: red;
`;

export const StyledButton = styled(Button)`
  width: 12rem;
  height: 4rem;
`;

export const StatisticContainer = styled.div`
  display: flex;
  gap: 1.6rem;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
